// extracted by mini-css-extract-plugin
module.exports = {"container":"icon-with-text_container__dapiQ","text":"icon-with-text_text__d0PQV"};